import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "components/Loader";
import OutlinedButton from "components/common/Button/OutlinedButton";
import { Input } from "antd";
import { t } from "i18next";
import { getSettings } from "store/slices";
import { useAppSelector } from "store/hooks";
import axiosInstance from "utils/axios";
import Label from "components/common/Label";
import { formatMessage } from "utils/utility";

const NewPassword = () => {
  const navigate = useNavigate();
  const [inputVales, setInputValues] = React.useState({
    password: "",
    confirmPassword: "",
    error: "",
    loading: false,
  });
  const { dir } = useAppSelector(getSettings);
  function handleSubmit() {
    if (!inputVales.password || !inputVales.confirmPassword) {
      setInputValues({
        ...inputVales,
        error: t("registerFillAllFields"),
      });
      return;
    }
    if (inputVales.password !== inputVales.confirmPassword) {
      setInputValues({
        ...inputVales,
        error: t("registerPasswordAndConfirmPasswordMustBeSame"),
      });
      return;
    }
    const passwordRegex =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+~`|}{[\]:;?><,./-])(?=.*[a-zA-Z]).{8,50}$/;
    if (!passwordRegex.test(inputVales.password)) {
      setInputValues({
        ...inputVales,
        error: t("passwordRequirments"),
      });
      return;
    }

    setInputValues({ ...inputVales, loading: true });
    axiosInstance
      .post("users/reset-password", {
        password: inputVales.password,
        confirm_password: inputVales.confirmPassword,
        email: sessionStorage.getItem("email"),
        otp: sessionStorage.getItem("otp"),
      })
      .then((res) => res.data)
      .then((data) => {
        setInputValues({ ...inputVales, loading: false });
        if (data.statusCode === 200) {
          sessionStorage.clear();
          navigate("/user-auth/login", {
            state: { success: "Password updated successfully!" },
          });
        } else {
          setInputValues({ ...inputVales, error: formatMessage(data.message) });
        }
      })
      .catch((error) => {
        setInputValues({
          ...inputVales,
          error: formatMessage(
            error?.response?.data?.message ?? "someThingWentWrong"
          ),
          loading: false,
        });
      });
  }

  return (
    <>
      <Loader open={inputVales.loading} position="portal" />
      <div className="flex flex-col max-w-sm w-full px-6 md:px-0" dir={dir}>
        <div className="flex flex-col gap-4 mb-6">
          {inputVales.error && (
            <p className="text-red-500 text-xs italic">
              {inputVales.error ?? "Something went wrong!"}
            </p>
          )}
          <Label>{t("newPasswordFormTitle")}</Label>
          <Input.Password
            id="password"
            type="password"
            placeholder={t("updatePasswordPasswordInput")}
            value={inputVales.password}
            onChange={(e) =>
              setInputValues({ ...inputVales, password: e.target.value })
            }
            note={t("passwordRequirments")}
            className="text-lg py-1"
          />
          <Input.Password
            id="confirmPassword"
            type="password"
            placeholder={t("updatePasswordConfirmPasswordInput")}
            value={inputVales.confirmPassword}
            onChange={(e) =>
              setInputValues({ ...inputVales, confirmPassword: e.target.value })
            }
            className="text-lg py-1"
          />
        </div>
        <div className="flex flex-col gap-3 items-center justify-center w-full">
          <OutlinedButton onClick={handleSubmit}>
            {t("updatePasswordButton")}
          </OutlinedButton>
          <Link
            className="text-gray-600 underline font-medium py-1 px-4 rounded-full focus:outline-none focus:shadow-outline text-sm"
            to="/user-auth/login"
          >
            {t("updatePasswordBackButton")}
          </Link>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
